import React, {useContext, useEffect} from "react";
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

const useBlocker = (confirmExit, when = true, leavePageClicked = null) => {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;

    navigator.push = (...args) => {
      if (leavePageClicked?.current) {
        leavePageClicked.current = false;
        return originalPush(...args);
      }
      confirmExit(...args);
    };

    return () => {
      navigator.push = originalPush;
    };
  }, [navigator, confirmExit, when]);
};

export default useBlocker;